import React from 'react';
import styled from 'styled-components';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Hidden from '@material-ui/core/Hidden';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Colors, Metrics, Heading3 } from '@origin-digital/style-guide';
import { System } from '../../CalculatorResult.types';
import Grid from '../../../../../../components/MuiGrid/Grid';

const SystemDetailsStyles = styled.div`
  padding-top: ${Metrics.Spacing.M_Y_XS}px;
  padding-left: ${Metrics.Spacing.M_Y_XS}px;
  padding-right: ${Metrics.Spacing.M_Y_XS}px;

  span {
    font-size: ${Metrics.FontSizes.BODY}px;
    color: ${Colors.GREY};
    white-space: nowrap;
  }
`;

const BorderDiv = styled.div`
  border-right: 1px solid ${Colors.GREY8};
  padding-bottom: ${Metrics.Spacing.M_Y_XS}px;
  padding-top: ${Metrics.Spacing.M_Y_XS}px;
`;

const useStyles = makeStyles({
  topMargin: {
    marginTop: `${Metrics.Spacing.M_Y_SM}px`
  }
});

export interface ISystemDetailsProps {
  system: System;
}

const SystemDetails: React.FunctionComponent<ISystemDetailsProps> = ({ system }) => {
  const classes = useStyles({});
  const theme = useTheme();
  const aboveMediumWidth = useMediaQuery(theme.breakpoints.up('lg'));
  return (
    <SystemDetailsStyles>
      <Grid
        container
        direction="row"
        justify="space-around"
        alignContent="center"
        className={`${classes.topMargin} system-details-grid-ie`}
      >
        <Grid
          item
          container
          direction="column"
          justify="flex-start"
          alignContent={aboveMediumWidth ? 'center' : 'flex-start'}
          xs={8}
          sm={8}
          md={8}
          lg={5}
          xl={5}
        >
          <Heading3 data-id="systemName" text={system.name} />
          <span>{system.description}</span>
        </Grid>
        <Hidden mdDown>
          <BorderDiv />
        </Hidden>
        <Grid
          item
          container
          direction="row"
          className={aboveMediumWidth ? '' : classes.topMargin}
          justify="center"
          alignContent="center"
          xs={5}
          sm={5}
          md={5}
          lg={3}
          xl={3}
        >
          <Grid item xs={4} sm={4} md={4} lg={4} xl={3}>
            <img
              src={
                'https://res.cloudinary.com/originenergy/image/upload/h_48,c_scale/v1548113577/solar/solar_inverter.png'
              }
            />
          </Grid>
          <Grid item container direction="column" xs={4} sm={5} md={4} lg={5} xl={5}>
            <Heading3 data-id="inverterWatts" text={`${system.inverter.watts / 1000} kW`} />
            <span>inverter</span>
          </Grid>
        </Grid>
        <BorderDiv />
        <Grid
          item
          container
          direction="row"
          className={aboveMediumWidth ? '' : classes.topMargin}
          justify="center"
          alignContent="center"
          xs={5}
          sm={5}
          md={3}
          lg={3}
          xl={3}
        >
          <Grid item xs={4} sm={4} md={4} lg={4} xl={3}>
            <img
              src={
                'https://res.cloudinary.com/originenergy/image/upload/h_48,c_scale/v1548113577/solar/solar_panel.png'
              }
            />
          </Grid>
          <Grid item container direction="column" xs={4} sm={5} md={4} lg={5} xl={5}>
            <Heading3 data-id="panelCount" text={`${system.solarPanels.panelCount}`} />
            <span>solar panels</span>
          </Grid>
        </Grid>
      </Grid>
    </SystemDetailsStyles>
  );
};

export default SystemDetails;
